
const plansTypes = {
  INIT_SUBSCRIPTION_PLANS: 'INIT_SUBSCRIPTION_PLANS',
};
export default plansTypes;